import { Injectable, signal } from '@angular/core';

export interface AppNotification {
  id: number;
  type: 'success' | 'error' | 'info' | 'warning';
  message: string;
  duration: number;
}

@Injectable({
  providedIn: 'root'
})
export class NotificationService {
  private notifications = signal<AppNotification[]>([]);
  readonly alerts = this.notifications.asReadonly();

  private nextId = 0;
  
  private add(type: AppNotification['type'], message: string, duration: number): void {
    const id = ++this.nextId;
    this.notifications.update(list => [...list, { id, type, message, duration }]);

    if (duration > 0) {
      setTimeout(() => this.dismiss(id), duration);
    }
  }

  success(message: string, duration: number = 4000): void {
    this.add('success', message, duration);
  }

  error(message: string, duration: number = 6000): void {
    this.add('error', message, duration);
  }

  info(message: string, duration: number = 3000): void {
    this.add('info', message, duration);
  }

  warning(message: string, duration: number = 5000): void {
    this.add('warning', message, duration);
  }

  dismiss(id: number): void {
    this.notifications.update(list => list.filter(n => n.id !== id));
  }
}
